import ClapperboardIcon from './ClapperboardIcon'

export default ClapperboardIcon
